import type { CSSProperties } from 'react'
import type { AutoCompleteProps } from 'antd'
import { useState, useMemo, useCallback, useEffect } from 'react'
import { AutoComplete } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { get, debounce } from 'lodash'
import 'src/styles/components/common/headerSearch.less'

type Props = {
  fullMode: boolean,
  dataSource: any[],
  filterFields: string[],
  optionKeyField: string,
  optionLabelFields: string[],
  acProps?: AutoCompleteProps,
  onSelect?: (val: string) => void,
  className?: string,
  style?: CSSProperties
}

const HeaderSearch = (props: Props) => {
  const [search, setSearch] = useState(false)

  const [filter, setFilter] = useState('')
  const handleFilterChange = useCallback(debounce((val: string) => {
    setFilter(val)
  }, 120), [])

  const options = useMemo(() => {
    const data = props.dataSource.filter(item => {
      return props.filterFields.find(field => {
        const value = get(item, field) ?? ''
        return filter && value.toLowerCase().indexOf(filter.toLowerCase()) !== -1
      })
    })
    return data.map((item: any) => ({
      label: props.optionLabelFields.map(field => get(item, field)).join('-'),
      value: get(item, props.optionKeyField),
    }))
  }, [props.dataSource, filter])

  const [value, setValue] = useState('')
  const handleSelectChange = (val: string) => {
    setValue('')
    props.onSelect?.(val)
  }
  useEffect(() => {
    handleFilterChange(value)
  }, [value])

  const visible = props.fullMode || search
  return (
    <div onClick={() => setSearch(true)} className='header-search'>
      <SearchOutlined className='header-search__icon' />
      <div
        className={`header-search__input ${visible ? 'show' : ''} ${props.className}`}
        style={props.style}
      >
        {
          visible
            ? (
              <AutoComplete
                autoFocus={!props.fullMode}
                {...props.acProps}
                value={value}
                options={options}
                onSearch={setValue}
                onSelect={handleSelectChange}
                onBlur={() => setSearch(false)}
              />
            )
            : null
        }
      </div>
    </div>
  )
}

HeaderSearch.defaultProps = {
  fullMode: false,
  filterFields: ['CODE', 'NAME'],
  optionKeyField: 'ID',
  optionLabelFields: ['NAME', 'CODE']
}

export default HeaderSearch